import { normalize } from "viem/ens";

const ETHEREUM_ADDRESS_RE = /^0x[a-fA-F0-9]{40}$/;

export function isValidEthereumAddress(address) {
  return typeof address === "string" && ETHEREUM_ADDRESS_RE.test(address.trim());
}

export function normalizeAddress(address) {
  if (!isValidEthereumAddress(address)) return "";
  return address.trim().toLowerCase();
}

export function normalizeEnsName(name) {
  if (typeof name !== "string") return null;

  const trimmedName = name.trim();
  if (!trimmedName) return null;

  try {
    return normalize(trimmedName);
  } catch {
    return null;
  }
}

export function isSameAddress(left, right) {
  const normalizedLeft = normalizeAddress(left);
  const normalizedRight = normalizeAddress(right);
  return Boolean(normalizedLeft && normalizedRight && normalizedLeft === normalizedRight);
}

export function formatWalletAddress(address, { prefix = 6, suffix = 4, separator = "..." } = {}) {
  if (!address) return "";
  const trimmed = String(address).trim();
  if (trimmed.length <= prefix + suffix) return trimmed;
  return `${trimmed.slice(0, prefix)}${separator}${trimmed.slice(-suffix)}`;
}

export function getVerifiedEnsDisplay({ address, reverseName, forwardAddress, fallback }) {
  const ensName = typeof reverseName === "string" ? reverseName.trim() : "";
  const isEnsVerified = Boolean(ensName && isSameAddress(address, forwardAddress));
  const fallbackName = fallback || formatWalletAddress(address);

  return {
    displayName: isEnsVerified ? ensName : fallbackName,
    ensName: isEnsVerified ? ensName : null,
    isEnsVerified,
    isFallback: !isEnsVerified,
  };
}
